import * as React from 'react';
import {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {
    CircularProgress,
    CssBaseline,
    Paper,
    TextField,
    Typography,
    Container,
    Grid,
    Button,
    InputAdornment, IconButton
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {connect} from "react-redux";
import {authActions} from "../../modules/authentication/auth.actions";
import {NavLink, useNavigate} from "react-router-dom";
import Constants from "../../utils/constants";
import './LoginPageNew.css'
import {Visibility, VisibilityOff} from "@mui/icons-material";

let useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        zIndex: 2
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

function LoginNew({dispatch, ...props}) {
    const [isSubmitting, setIsSubmitting] = React.useState()
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false)

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        if (props.loggedIn) {
            // If already logged in, redirect to home
            navigate(Constants.APP_ROUTE_HOME);
        }
    }, [navigate, props.loggedIn])


    const classes = useStyles();
    const {register, handleSubmit, errors} = useForm();

    const onSubmit = data => {
        setIsSubmitting(true);
        dispatch(authActions.login(data.email, data.password))
    }

    return (
        <Container component="main" maxWidth="xs" className={"loginContainer"}>
            <CssBaseline/>

            <Typography component="h1" variant="h4" className={"login-title"}
                        sx={{textAlign: 'center', marginTop: '-5rem', marginBottom: '5rem'}}>
                LES EUGENE, SPECIALISTES DU LAVAGE DE CONTENANTS A DECHETS
            </Typography>

            <Paper elevation={24} className={"loginFormContainer"}>

                {/*<div className="logo_eugene"></div>*/}
                <div className={"logoWrapper"}>
                    <img src={`/images/logo_marquedeposee_blanc_vert_small.png`}
                         alt="Logo Les Eugene"/>
                </div>


                <form className={classes.form} noValidate onSubmit={handleSubmit(onSubmit)}>
                    <Grid container className={"mt-1 mb-1"}>
                        <Grid item md={1}></Grid>
                        <Grid item xs={12} md={10}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="email"
                                label="Email *"
                                autoFocus
                                autoComplete={"username"}
                                className={"login-form-input"}
                                {...register("email", {required: true})}
                            />
                            {errors && errors.email && <span className="form-error">ce champ est requis</span>}
                        </Grid>
                    </Grid>

                    <Grid container className={"mt-1 mb-2"}>
                        <Grid item md={1}></Grid>
                        <Grid item xs={12} md={10}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Mot de passe"
                                type={showPassword ? "text" : "password"}
                                id="password"
                                name="password"
                                autoComplete={"current-password"}
                                className={"login-form-input"}
                                {...register("password", {required: true})}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {showPassword ? <VisibilityOff/> : <Visibility/>}
                                            </IconButton>
                                        </InputAdornment>
                                }}
                            />
                            {errors && errors.password && <span className="form-error">ce champ est requis</span>}
                        </Grid>
                        <Grid container>
                            <Grid item xs={1}></Grid>
                            <Grid item md={10} alignItems={"end"}>
                                <NavLink to={"/forgotPassword"}>
                                    <Typography color={"white"} sx={{textAlign: "right"}}>Mot de passe oublié
                                        ?</Typography>
                                </NavLink>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container className={"mt-2 mb-2"} justifyContent={"center"} alignItems={"center"}>
                        <Grid item xs={6}>
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                className={"login-form-submit"}
                                disabled={isSubmitting && props.error === false}>
                                {!(isSubmitting && props.error === false) &&
                                    <Typography sx={{color: 'black', padding: '.5rem', fontWeight: 'semi-bold'}}>Se
                                        connecter</Typography>
                                }
                                {(isSubmitting && props.error === false) &&
                                    <CircularProgress size={40} color={"primary"}/>}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
                <img src={"/images/poubelle-alpha.png"} alt={"poubelle"}
                     className={"login-poubelle"}/>
            </Paper>

            <img src={"/images/laveuse.png"} alt={"laveuses"} className={"login-laveuse"}/>

            <img src={"/images/eugene.png"} alt={"Eugene"} className={"login-eugene"}/>

        </Container>
    )
}


const mapStateToProps = function (state) {
    return {
        loggedIn: state.authentication.loggedIn,
        error: state.authentication.error,
    }
}

const LoginPageNew = connect(mapStateToProps)(LoginNew)

export default LoginPageNew;
